// @flow
import { Record, Map as ImmutableMap } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

// ================================================================================================
// CategoriesStore
// ================================================================================================

export const CategoryTypeEnum = Object.freeze({
  INCOME: 'INCOME',
  EXPENSE: 'EXPENSE',
});
export type CategoryType = $Values<typeof CategoryTypeEnum>; // eslint-disable-line no-undef

type CategoriesStoreProps = QcsSyncResourceStoreProps & {

};
export type CategoriesStore = RecordOf<CategoriesStoreProps>;
export const mkCategoriesStore: RecordFactory<CategoriesStoreProps> =
  Record({
    resourcesById: ImmutableMap(),

    lastSyncDate: null,
    loadPending: true,

    isLoading: false,
  });

type CategoryProps = {
  id: string,

  parentId: string,
  type: CategoryType,

  name: string,
  description: ?string,

  isExcludedFromCategoryList: ?boolean,
  isDeleted: ?boolean,

  clientId: ?string,
  parentClientId: ?string,
  knownCategoryId: ?string,
  logoUrl: ?string,
};
export type Category = RecordOf<CategoryProps>;

export const mkCategory: RecordFactory<CategoryProps> =
  Record({
    id: undefined,

    parentId: undefined,
    type: undefined,

    name: undefined,
    description: undefined,

    isExcludedFromCategoryList: false,
    isDeleted: false,

    clientId: undefined,
    parentClientId: undefined,
    knownCategoryId: undefined,
    logoUrl: undefined,
  });


